import { SupplierDetailPage } from '@/features/companies/pages/detail-page/supplier-detail';

export const SupplierDetailRoute = () => {
  return <SupplierDetailPage />;
};
